/**
 * 主视图装饰器
 */

import {mergeModelData} from '../../../util/index.js';
import el from "element-ui/src/locale/lang/el";
import FootDectorator from "../footdectorator";
// import Component from "../../component";
import BaseContext from "../../basecontext";
const model = {
  mainContextKey: {
    Type: Number,
    Required: true,
  }
};
const MainDectorator = BaseClass => class extends BaseClass {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _calcGrid() {
    const {width, height, top, left, isFullScreen} = this.state;
    const {size, fullSize} = this.option.MainContext;
    const {
      left: dleft,
      top: dtop,
      right: dright,
      bottom: dbottom
    } = !isFullScreen ? size : fullSize;
    this.availArea = {
      left: left + width * dleft,
      top: top + height * dtop,
      right: left + width * (1 - dright),
      bottom: top + height * (1 - dbottom),
      width: width * (1 - dleft - dright),
      height: height * (1 - dtop - dbottom)
    };
  }
  _drawGrid() {
    const {height, width, top, left, right} = this.availArea;
    const dashAmount = 6;
    const x1 = left;
    const x2 = right;
    const {dashColor, solidColor} = this.option.MainContext;
    for (let i = 0; i < dashAmount; i++) {
      const axisY = top + (height / dashAmount) * i;
      const p1 = {x: x1, y: axisY};
      const p2 = {x: x2, y: axisY};
      // if(i == 0 || i == 3){
        // this._drawSolid(p1, p2, this.dpr * 0.5, dashColor);
      // } else {
        this._drawDash(p1, p2, this.dpr * 0.2, dashColor);
      // }
    }
    const axisY = top + height;
    // 主视图的下边框
    this._drawSolid({x: x1, y: axisY}, {x: x2, y: axisY}, this.dpr * 0.8, solidColor);
  }
  _showCursor({x, index}) {
    const {len} = this.state.data;
    if(!len) {
      // 绘图长度为0时不显示十字线
      return
    }
    // 分时无数据时十字线报错问题
    let {y, text,high,low} = this._calcCursorAxis(index) || {y:null,text:null,high:null,low:null};
    const ctx2 = this.curContext;
    const {ratioFixed} = this.state.data.sealObj;
    const {left,
      // top,
      width, right, bottom} = this.availArea;
    const {top} = this.state
    const baseSize = this.state.baseSize;
    const {
      ball,
      crossPoint,
      label,
    } = this.option.MainContext;
    const {
      spaceX,
      spaceY,
      radius,
      sizeRatio,
      fontFamily,
      color,
      backColor,
      lineWidth,
    } = label;
    /*** 绘制Y轴标签 ***/
    ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
    ctx2.textAlign = 'center';
    ctx2.textBaseline = 'middle';
    text = text && text.toFixed(ratioFixed);
    const textWidth = ctx2.measureText(text).width;
    const labelWidth = textWidth + 2 * spaceX;
    const labelHeight = sizeRatio * baseSize * this.dpr + 2 * spaceY;
    y = bottom - y;
    let leftX;
    let topY = y - labelHeight / 2;
    let p1 = {}, p2 = {};
    // 小于1/4则右侧显示label
    if (x < left + Math.max(width / 4, labelWidth)) {
      leftX = right - labelWidth;
      p1.x = left;
      p2.x = leftX;
    } else {
      leftX = left;
      p1.x = leftX;
      p2.x = right;
    }
    if (topY < top) {
      topY = top;
    } else if (topY > bottom - labelHeight) {
      topY = bottom - labelHeight;
    }
    //topY矩形最高点距离顶部的距离
    p1.y = p2.y = y;
    
    // 主图纵向十字线
    if(high==null){
      this._drawDash({x, y: top}, {x, y: bottom}, this.dpr/2 , backColor,5, 3,ctx2);
    }else {
      this._drawDash({x, y: top}, {x, y: bottom-high}, this.dpr/2 , backColor,5, 3,ctx2);
      this._drawDash({x, y: bottom-low}, {x, y: bottom}, this.dpr/2 , backColor,5, 3,ctx2);
    }
    // 主图横向十字线
    this._drawDash(p1, p2, this.dpr/2 , backColor,5, 3,ctx2); // 横向

    // this._drawSolid({x, y: top}, {x, y: bottom}, lineWidth*4, backColor, ctx2);
    // this._drawSolid(p1, p2, lineWidth*4, backColor, ctx2);
    if (crossPoint.show) {
      const {
        radius,
        lineWidth,
        color,
        backColor,
      } = crossPoint;
      ctx2.strokeStyle = color;
      ctx2.fillStyle = backColor;
      ctx2.lineWidth = lineWidth * this.dpr;
      ctx2.beginPath();
      ctx2.arc(x, y, radius, Math.PI * 2, false);
      ctx2.fill();
      ctx2.stroke();
    }
    this._drawBoxRadius({
      left: leftX,
      top: topY,
      width: labelWidth,
      height: labelHeight,
      radius,
      strokeStyle: backColor,
      fillStyle: backColor
    });
    ctx2.textAlign = 'center';
    ctx2.textBaseline = 'middle';
    ctx2.fillStyle = color;
    ctx2.fillText(text, leftX + labelWidth / 2, topY + labelHeight / 2);

    /*** 绘制弹窗 ***/
    this._calcFloatWinData(x)
  }
  _hideCursor() {}
}
export default MainDectorator;
